import { pullRefreshProps } from "vant";


//#region 系统用枚举

/**
 * 返回值Code值
 */
export enum ResultCodeEnum {
    /**
     * 成功
     */
    Success = 200,
    /**
     * 错误
     */
    Error = 400,
    /**
     * 未授权(未登录)
     */
    UnAuthorized = 401,
    /**
     * 无权访问
     */
    Forbidden = 403
}


/// <summary>
/// 角色类型
/// </summary>
export enum RoleTypeEnum {
    /**
     * 未知
     */
    None = -1,
    /**
     * 系统角色
     */
    System = 99,

    /**
     * 代理商账号
     */
    Agent = 3,

    /**
     * 主操作员
     */
    MainOperator = 1,
    /**
     * 子操作员(是主操作员的下级)
     */
    SubOperator = 2
}

/**
 * 账号状态
 */
export enum AccountStatusEnum {
    /**
     * 可用
     */
    Available = 1,
    /**
     * 禁用
     */
    Disable = 0
}

/**
 * 设备状态
 */
export enum DeviceStatusEnum {
    /**
     * 可用
     */
    Available = 1,
    /**
     * 禁用
     */
    Disable = 0
}

/**
主题类型枚举
设备优先级(设备-->用户-->群组)
如果存在单独设备级别则优先播设备,其次是用户级，剩余是群组
 */
export enum TopicTypeEnum {
    /**
     * 未知
     */
    None = 0,
    /**
     * 设备(支持指令与广告投放)
     */
    Device = 1,
    /**
     * 用户(支持指令与广告投放)
     */
    User = 2,
    /**
     * 组(只支持广告投放)
     */
    Group = 3
}

/**
 * MQTT推送类型
 */
export enum MQTTPushType {
    /**
     * 未知
     */
    None,
    /**
     * 指令
     */
    Action,
    /**
     * 广告
     */
    Advertisement
}

/**
 * 消费类型
 */
export enum ConsumptionTypeEnum {
    /**
     * 未知
     */
    None = 0,
    /**
     * 创建广告推广
     */
    CreateExtensionAdvertisement = 1,
    /**
     * 购买模板
     */
    BuyTemplate = 2,
    /**
     * 出售模板
     */
    SellingTemplates = 3
}

/**
 * 直播类型
 */
export enum LiveTypeEnum{
    None,
    /**
     * 抖音
     */
    DouYin
}

/**
 * 推广广告加入媒体类型审核状态标识枚举
 */
export enum ExtensionTopicJoinApplyStatusEnum {
    /**
     * 未审核
     */
    UnAudited = 0,
    /**
     * 通过
     */
    Approve = 1,
    /**
     * 拒绝
     */
    Refuse = 2
}



/**
 * 颜色枚举
 */
export enum ColorEnum {
    /**
     * 成功
     */
    "Success" = "#63e2b7",
    /**
     * 提示
     */
    "Info" = "#70c0e8",
    /**
     * 警告
     */
    "Warning" = "#f2c97d",
    /**
     * 错误
     */
    "Error" = "#e88080"
}

//#endregion



//#region VUE项目内部使用的枚举

/**
 * 记录类型枚举
 */
export enum RecordTypeEnum {
    "充值记录" = "GetRechargeRecordAsync",
    "推广记录" = "GetMyAdExposureRecordAsync",
    "收益记录" = "GetMyConsumptioOrRevenueRecordAsync",
    "消费记录" = "GetMyConsumptioOrRevenueRecordAsync"
}

export enum ConsumptioOrRevenueTypeEnum {
    /**
     * 未知
     */
    None,
    /**
     * 消费
     */
    Consumptio,
    /**
     * 收益
     */
    Revenue
}

//#endregion


/**
 * 模板类型枚举
 */
export enum TemplateTypeEnum {
    /**
     * 未知
     */
    None = 0,
    /**
     * 文字可显示
     */
    Font = 1,
    Image = 2,
    Video = 3,
    Audio = 4,
    QRCode = 5,
    Size = 6,
    /**
     * 贴纸
     */
    Stickers = 7,
    /**
     * 模板
     */
    Temp = 8,
    /**
     * 水印
     */
    WaterMark = 9,
    /**
     * 游戏类
     */
    Game = 10,
    /**
     * 3D模型
     */
    Model3D = 11,
    /**
     * 背景
     */
    Background = 12,
    /**
     * 页类型
     */
    Page = 13
}

/**
 * 资源类型
 */
export enum ResourceTypeEnum {
    /**
     * 未知
     */
    None = 0,
    /**
     * 背景库
     */
    BackgroundLibrary = 1,
    /**
     * 图库
     */
    ImageLibrary = 2,
    /**
     * 贴纸
     */
    StickersLibrary = 3,
    /**
     * 花字(特别好看的文字库)
     */
    PrettyFontLibrary = 4,
    /**
     * 字体库
     */
    FontLibrary = 5,
    /**
     * 视频库
     */
    VideoLibrary = 6,
    /**
     * 音频库
     */
    AudioLibrary = 7,
    /**
     * 游戏库
     */
    GameLibrary = 8,
    /**
     * 3D模型库
     */
    Model3DLibrary = 9,
    /**
     * 生成的音频库
     */
    GenerateAudioLibrary = 10,
    /**
     * 相册
     */
    Album = 11,
    /**
     * 选择颜色
     */
    Color = 12,
    /**
     * 动画库
     */
    Animation = 13
}

export enum MQTTPushTypeEnum {
    /**
     * 默认
     */
    None,

    /**
     * 指令
     */
    Action,

    /**
     * 广告
     */
    Advertisement
}

/**
 * 表单类型
 */
export enum FormTypeEnum {
    /**
     * 未知
     */
    None,
    /**
     * 输入框
     */
    Input,
    /**
     * 开关
     */
    Switch,
    /**
     * 选择器
     */
    Select,
    /**
     * 复选框
     */
    Checkbox,
    /**
     * 单选框
     */
    Radio,
    /**
     * 步进器(+1 -1啥的)
     */
    Stepper,
    /**
     * 评分(选星的)
     */
    Rate,
    /**
     * 滑块
     */
    Slider,
    /**
     * 上传图片
     */
    UploadImage,
    /**
     * 选择器
     */
    Picker,
    /**
     * 日期选择器
     */
    DatePicker,
    /**
     * 日期+时间选择器
     */
    DatePickerGroup,
    /**
     * 时间选择器
     */
    TimePicker,
    /**
     * 日历
     */
    Calendar
}

/**
 * 资源来源类型枚举
 */
export enum ResourceSourceTypeEnum{
    /**
     * 未知
     */
    None = -1,
    /**
     * 普通网络数据
     */
    NetworkResource = 0,
    /**
     * 相册图片
     */
    AlbumImageResource = 1,
    /**
     * 相册视频
     */
    AlbumVideoResource = 2
}